import angular from 'angular';
import mobilePreviewActions from './mobile-preview-actions/mobile-preview-actions';
import SelfVideoFrameMiniController from './self-video-frame-mini.controller';
import template from './self-video-frame-mini.html';
const selfVideoFrameMiniComponent = {
    template,
    bindings: {
        withVideo: '<',
        videoPublisherId: '<',
        isVideoDisabled: '<',
        isInGroupCall: '<',
        isGalleryView: '<',
        onSelect: '&',
        isPinned: '<',
        isInCall: '<',
        avatarPicture: '<',
        cameraOff: '<',
        isPatient: '<',
        hasSelfPublisherError: '<',
        isCheckInPhotoCaptureEnabled: '<',
    },
    controller: SelfVideoFrameMiniController,
};
export default angular
    .module('doxy.videoChat.callFrames.selfVideoFrameMiniComponent', [
    mobilePreviewActions,
])
    .component('selfVideoFrameMini', selfVideoFrameMiniComponent).name;
